import { Button } from "@material-tailwind/react";
import React from "react";

const AboutPage = () => {
  return (
    <div>
      <h1 className="text-2xl">About Page</h1>
      <Button color="red" className="px-3">Click me</Button>
      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aut praesentium vel harum distinctio, asperiores suscipit voluptate quam enim odio delectus neque dolore porro atque mollitia culpa laborum accusantium excepturi cum ducimus facere, illo itaque, ipsam optio. Illum similique aut ex at, saepe quidem hic, suscipit dicta libero consequatur, quam consequuntur totam odio facilis harum adipisci nesciunt asperiores laudantium est praesentium obcaecati quisquam neque dignissimos. Ut nobis cumque sint eveniet tenetur porro in incidunt modi distinctio excepturi error provident molestias dolor aspernatur sequi dolores quas maxime velit quis aut, omnis, labore, possimus animi. Nemo sequi iure repellat nisi non reiciendis fugit.</p>
    </div>
  );
};

export default AboutPage;
